import LazyLoad from '../common/lazyLoad'

const fn = {
  init: () => {
    LazyLoad.init()
  }
}

export default {
  can: () => true,
  run: fn.init
}
